<template>
  <v-dialog v-model="show" fullscreen>
    <v-card>
      <v-card-title>{{ mode }} Playback Item</v-card-title>
      <v-card-text>
        <v-form ref="form" @submit.prevent="submit">
          <v-text-field
            v-model="form.name"
            label="Name"
            required
          ></v-text-field>
          <v-textarea
            v-model="form.description"
            label="Description"
            required
          ></v-textarea>
          <v-text-field v-model="form.youTubeUrl" label="YouTube Url" required></v-text-field>
          <v-card-actions>
            <v-btn text @click="$emit('close')">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn :loading="isSaving" color="primary" type="submit">
              {{ mode }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import loading from '../mixins/loading';
import validation from './validation';

/**
 * A Vue component that displays a modal for creating/editing a new playbackItem.
 */
export default {
  name: 'ModalPlaybackItem',
  mixins: [loading, validation],
  props: {
    playbackItem: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        name: '',
        description: '',
        image: '',
        streamUrl: '',
        start: undefined,
        end: undefined,
      },
    };
  },
  computed: {
    baseUrl() {
      return process.env.VUE_APP_APIURL;
    },
    mode() {
      return this.playbackItem?.id ? 'Update' : 'Create';
    },
  },
  watch: {
    playbackItem: {
      immediate: true,
      deep: true,
      handler() {
        this.form = this.playbackItem ?? {};
      },
    },
  },
  mounted() {
    this.form = this.playbackItem ?? {};
  },
  methods: {
    featuredImageUploaded(file) {
      this.playbackItem.image = `${this.baseUrl}/api/gallery/${file.id}`;
    },
    /**
     * Submit the form data to the backend.
     */
    async submit() {
      this.isSaving = true;
      this.$emit('submit', this.form);
      this.$refs.form.reset();
      this.isSaving = false;
    },
  },
};
</script>
